module.exports = __webpack_public_path__ + "5af7300808935fe5789515f62654f210.woff2";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-bold.woff2
// module id = 1059
// module chunks = 0